import { axios, axiosHelper } from "@/axios";
import config from "@/config/config";

export const userService = {
  login,
  logout,
  register,
  updateZip,
  updateCategories,
  updateEntertainment,
  getAll,
  getById,
  update,
  delete: _delete,
  getEntertainment,
  getLoggedInUser,
  verifyEmail,
  verifyOTP,
  updateProfile,
  updatePreferences,
  verifyPresenter,
  followUser,
  unfollowUser,
  linkProfile,
  resetPassword,
  validateReset,
  updatePassword,
  fixHours
};

// Define a function daylights_savings that takes a Date object dt as input
function daylights_savings(dt) {
  // Initialize a variable dst to null to store the daylight savings time offset
  var dst = null;
  // Iterate over the months of the year
  for (var i = 0; i < 12; ++i) {
    // Create a new Date object for the current year and month
    var d = new Date(dt.getFullYear(), i, 1);
    // Retrieve the timezone offset for the current date
    var offset = d.getTimezoneOffset();

    // Check if the daylight savings time offset has been set
    if (dst === null)
      dst = offset;
    // If the current offset is less than the previously stored offset, update the dst variable
    else if (offset < dst) {
      dst = offset;
      // Exit the loop if a lower offset is found
      break;
    }
    // If the current offset is greater than the previously stored offset, exit the loop
    else if (offset > dst)
      break;
  }
  // Return 1 if the timezone offset of the provided date matches the daylight savings offset, else return 0
  return (dt.getTimezoneOffset() == dst) | 0;
}


function fixHours(val, isDST) {
  let hrv = 0;
  let mins = 0;
  if (val) {
    if (isDST && !daylights_savings(typeof val == 'string' ? new Date(val) : val)) {
      hrv = 1
    }

    if (new Date().toString().includes('GMT+1100 (Lord Howe Daylight Time)')) {
      mins = 30;
      hrv = 0
    }
  }

  return { hrv, mins }
}

function linkProfile(phoneNumber, username, email, password, isSocial, socialType, socialId) {
  return axios.post("/api/link_social_account", {
    phoneNumber,
    username,
    email,
    password,
    isSocial,
    socialType,
    socialId
  }).then(axiosHelper.handleResponse)
    .then((user) => user.Result)
    .catch(error => {
      const err = (error && error.response && error.response.data && error.response.data.Message) ? error.response.data.Message : error.message;
      return { error: true, message: err };
    });
}

function login(username, phone, email, password, isSocial, socialType, socialId) {
  return axios
    .post("/api/login", {
      email: email,
      password: password,
      phoneNumber: phone,
      username: username,
      isSocial: isSocial || "0",
      socialType: socialType || "",
      socialId: socialId || "",
    })
    .then(axiosHelper.handleResponse)
    .then((user) => {
      // login successful if there's a jwt token in the response
      localStorage.setItem("user", JSON.stringify(user.Result));

      // Reset Event Form Data
      localStorage.removeItem("formData");
      localStorage.removeItem("activeStep");
      localStorage.removeItem("stepsData");

      return user.Result;
    }).catch(error => {
      const err = (error && error.response && error.response.data && error.response.data.Message) ? error.response.data.Message : error.message;

      return { error: true, message: err };
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
}

function verifyOTP(params) {
  return axios
    .post("/api/verify_email_otp", params)
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user;
    });
}

function updatePreferences(params) {
  return axios
    .post("/api/update_preference", params)
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user;
    });
}

function verifyEmail(params) {
  return axios
    .post("/api/verify_email", params)
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user.Result;
    });
}

function register(params) {
  return axios
    .post("/api/signup", params)
    .then(axiosHelper.handleResponse)
    .then((user) => {
      // let userId = user.Result.id;

      // // Update Zip Code
      // const zipParams = {
      //     userId: userId,
      //     zipcode: params.zipcode
      // }
      // updateZip(zipParams);

      // // Update Categories
      // const catParams = {
      //     userId: userId,
      //     categories: params.categories
      // }
      // updateCategories(catParams);

      // // Update Entertainment
      // const entertainParams = {
      //     userId: userId,
      //     phrases: params.entertainmentPhrases
      // }
      // updateEntertainment(entertainParams);

      // Reset Event Form Data
      localStorage.removeItem("formData");
      localStorage.removeItem("activeStep");
      localStorage.removeItem("stepsData");

      return user.Result;
    }).catch(error => {
      const err = (error && error.response && error.response.data && error.response.data.Message) ? error.response.data.Message : error.message;

      return { error: true, message: err };
    });
}

function updateZip(params) {
  return axios
    .post("/api/update_zipcode", params)
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user.Result;
    });
}

function updateCategories(params) {
  return axios
    .post("/api/update_categories", params)
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user.Result;
    });
}

function updateEntertainment(params) {
  return axios
    .post("/api/update_phrases", params)
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user.Result;
    });
}

function getAll() {
  const requestOptions = {
    method: "GET",
    // headers: authHeader()
  };

  return fetch(`${config.API_URL}/users`, requestOptions).then(
    axiosHelper.handleResponse
  );
}

function authHeader() {
  return {
    Authorization: "test",
  };
}

function getLoggedInUser(userId) {
  return axios
    .post(`${config.API_URL}/api/fetch_loggedIn_user`, { userId })
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user.Result;
    });
}

function getById(id) {
  const requestOptions = {
    method: "GET",
    // headers: authHeader()
  };

  return fetch(`${config.API_URL}/users/${id}`, requestOptions).then(
    axiosHelper.handleResponse
  );
}

function updateProfile(params) {
  return axios
    .post("/api/update_profile", params)
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user.Result;
    });
}

function update(user) {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };

  return fetch(`${config.API_URL}/users/${user.id}`, requestOptions).then(
    axiosHelper.handleResponse
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(`${config.API_URL}/users/${id}`, requestOptions).then(
    axiosHelper.handleResponse
  );
}

function getEntertainment() {
  return axios
    .get("/api/metadata", {})
    .then(axiosHelper.handleResponse)
    .then((entertainment) => {
      return entertainment["Result"]["Entertainment Phrases"];
    });
}

function verifyPresenter(email) {
  return axios
    .post("/api/validate_presenters", {
      presenterEmail: email,
    })
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user.Result;
    }).catch(error => {
      const err = (error && error.response && error.response.data && error.response.data.Message) ? error.response.data.Message : error.message;

      return { error: true, message: err };
    });
}


function followUser(params) {
  return axios.post("/api/follow_user", params)
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user.Result;
    })
    .catch((err) => ({ error: true, message: err }));
}

function unfollowUser(params) {
  return axios.post("/api/unfollow_user", params)
    .then(axiosHelper.handleResponse)
    .then((user) => {
      return user.Result;
    })
    .catch((err) => ({ error: true, message: err }));
}

/**
 * This function here is used to reset password
 * @params body
 * @returns fetched data promise
 */
function resetPassword(body) {
  return axios
    .post("/api/reset_password", body)
    .then(axiosHelper.handleResponse)
    .then(response => response)
    .catch(error => error);
}

/**
 * This function here is used to reset password
 * @params body
 * @returns fetched data promise
 */
function validateReset(body) {
  return axios
    .post("/api/validate_reset_request", body)
    .then(axiosHelper.handleResponse)
    .then(response => response)
    .catch(error => error);
}

/**
 * This function here is used to reset password
 * @params body
 * @returns fetched data promise
 */
function updatePassword(body) {
  return axios
    .post("/api/update_password", body)
    .then(axiosHelper.handleResponse)
    .then(response => response)
    .catch(error => error);
}
